
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import Chart from 'chart.js';
import chartjs_plugin_annotation from 'chartjs-plugin-annotation';
import menu_icon from "../assets/menu.svg";
export default {
  on: {
    pageAfterIn: function () {//console.log("pageAfterIn");
    },
    pageBeforeIn: function () {
      //console.log("pageBeforeIn");
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.ptr.refresh('.home-ptr-content');
      self.$setState({
        user: window.identity,
        country: window.country,
        allowCountrySwitch: Object.keys(window.identity['countries']).length > 1
      }, function () {});
    }
  },
  mounted: function () {
    console.warn(Chart);
    console.warn(chartjs_plugin_annotation);
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    $$('.home-ptr-content').on('ptr:refresh', function (e) {
      //console.log("ptr:refresh");
      self.loadPermissions(() => {
        self.loadData();
      });
      window.reloadIdentity(false, function () {
        self.$setState({
          user: window.identity,
          country: window.country,
          allowCountrySwitch: Object.keys(window.identity['countries']).length > 1
        });
      });
    });
    self.$tick(function () {//app.ptr.refresh('.home-ptr-content')
    });
  },
  beforeMount: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    $$(".view-my-mitsu").once("tab:show", function () {
      app.ptr.refresh('.home-ptr-content');
    });
  },
  data: function () {
    let permissionsCache = localStorage.getItem("PERMISSIONS_CACHE");
    var permissions = {};

    if (permissionsCache) {
      permissions = JSON.parse(permissionsCache);
    }

    return {
      menu_icon: menu_icon,
      locations: [],
      reports: [],
      contracts: [],
      activerequests: [],
      hideSwiperNavigation: true,
      //
      maintenances: [],
      repairs: [],
      works: [],
      user: {},
      //
      cachedgrouped: {},
      grouped: {},
      loadingReports: false,
      oneLocation: false,
      loadingCharts: true,
      repairs_total: 0,
      maintenances_total: 0,
      time_on_site_total: 0,
      selected_location_name: "All",
      cbData: [],
      pmData: [],
      time_on_site_data: [],
      chartsLabels: [],
      equipments_count: 0,
      filterByEquipmentId: {},
      filterByEquipmentName: {},
      enable_pm_hrs_widget: false,
      enable_time_on_site_hrs_widget: false,
      //
      country: window.country,
      allowCountrySwitch: Object.keys(window.identity['countries']).length > 1,
      //
      loadingCertificates: false,
      hide_certificates: true,
      //
      permissions: permissions
    };
  },
  methods: {
    loadPermissions: function (callback) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("user/permissions"),
        preloader: false,
        progress: true,
        success: function (data, status, xhr) {
          console.error(data);
          self.$setState({
            permissions: data
          }, callback);
          localStorage.setItem("PERMISSIONS_CACHE", JSON.stringify(data));
        }
      });
    },

    displayPhone() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.dialog.alert("Our customer support is ready to help, call us now on:<br/><strong style='font-size: 18px;' class='text-color-primary'>" + app.data.phone + "</strong>", '');
    },

    openCountrySwitcher() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var buttons = [];
      Object.keys(window.identity['countries']).forEach(country_code => {
        var listHtml = `<div class="list no-hairlines no-margin-top"><ul style="background: transparent">`;
        listHtml += `
                    <li>
                        <a href="#" class="item-link item-content" data-country="${country_code}" data-name="${window.identity['countries'][country_code]}">
                            <div class="item-media"><i class="iti__flag iti__${country_code}"></i></div>
                            <div class="item-inner">
                                <div class="item-title text-color-black" style="line-height: normal;">${window.identity['countries'][country_code]}</div>
                            </div>
                        </a>
                    </li>`;
        listHtml += `</ul></div>`;
        buttons.push({
          text: listHtml,

          onClick() {
            window.switchToCountry(country_code);
          }

        });
      });
      app.dialog.create({
        title: "Select country",
        //text: '',
        //content: fullHtml,
        verticalButtons: true,
        buttons: buttons,
        on: {}
      }).open();
    },

    selectLocation: function (id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.selected_location_name = "All";
      window.selected_location = id;
      self.locations.forEach(loc => {
        if (loc.id === parseInt(id)) {
          self.selected_location_name = loc.name;
        }
      });
      self.$update(function () {
        if (self.permissions['CALL_BACK_NUMBER'] || self.permissions['TIME_ON_SITE']) {
          self.getLocationCharts(id);
        }
      });
    },
    getLocationCharts: function (id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.loadingCharts = true;
      self.$update(() => {
        app.request({
          url: Url.to("location/get-charts-data"),
          method: "GET",
          data: {
            id: id
          },
          preloader: false,
          indicator: false,
          progress: false,
          success: function (data, status, xhr) {
            console.log(data);
            self.loadingCharts = false;
            self.repairs_total = data['repairs_total']; //self.maintenances_total = data['maintenances_total'];

            self.chartsLabels = data['dates'];
            self.equipments_count = data['equipments_count'];
            self.cbData = data['repairs']; //self.pmData = data['maintenances'];
            //self.enable_pm_hrs_widget = data['enable_pm_hrs_widget'];

            self.time_on_site_data = data['time_on_site_data'];
            self.time_on_site_total = data['time_on_site_total'];
            self.enable_time_on_site_hrs_widget = data['enable_time_on_site_hrs_widget'];
            self.$update(() => {
              if (self.permissions['CALL_BACK_NUMBER']) {
                var ctx = document.getElementById('cb-chart');
                const annotation = {
                  id: 'a-line-1',
                  // optional
                  drawTime: 'afterDraw',
                  type: 'line',
                  mode: 'horizontal',
                  scaleID: 'y-axis-0',
                  borderColor: '#378cff',
                  borderDash: [2, 2],
                  borderDashOffset: 0,
                  borderWidth: 1,
                  label: {
                    enabled: false
                  },
                  value: window.average(self.cbData)
                };
                var myChart = new Chart(ctx, {
                  type: 'line',
                  data: {
                    labels: data['repairs'],
                    datasets: [{
                      cubicInterpolationMode: "monotone",
                      lineTension: 0,
                      pointStyle: null,
                      pointRadius: 0,
                      borderWidth: 1,
                      borderColor: 'rgba(55,140,255,0.8)',
                      backgroundColor: 'rgba(55,140,255,0.1)',
                      label: 'PM Count',
                      data: data['repairs']
                    }]
                  },
                  options: {
                    animation: false,
                    spanGaps: true,
                    parsing: false,
                    title: {
                      display: false
                    },
                    legend: {
                      display: false
                    },
                    scales: {
                      xAxes: [{
                        display: false,
                        scaleLabel: {
                          display: false
                        }
                      }],
                      yAxes: [{
                        display: false,
                        scaleLabel: {
                          display: true
                        },
                        ticks: {
                          display: false,
                          beginAtZero: true
                        }
                      }]
                    },
                    elements: {
                      point: {
                        radius: 0 // default to disabled in all datasets

                      }
                    },
                    annotation: {
                      annotations: [annotation]
                    }
                  }
                });
              }

              if (self.permissions['TIME_ON_SITE']) {
                if (self.enable_time_on_site_hrs_widget) {
                  var ctx2 = document.getElementById('pm-chart');
                  const annotation2 = {
                    id: 'a-line-1',
                    // optional
                    drawTime: 'afterDraw',
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    borderColor: '#378cff',
                    borderDash: [2, 2],
                    borderDashOffset: 0,
                    borderWidth: 1,
                    label: {
                      enabled: false
                    },
                    value: window.average(self.time_on_site_data)
                  };
                  var myChart2 = new Chart(ctx2, {
                    type: 'line',
                    data: {
                      labels: data['time_on_site_data'],
                      datasets: [{
                        cubicInterpolationMode: "monotone",
                        lineTension: 0,
                        pointStyle: null,
                        pointRadius: 0,
                        borderWidth: 1,
                        borderColor: 'rgba(55,140,255,0.8)',
                        backgroundColor: 'rgba(55,140,255,0.1)',
                        label: 'TOS Hours',
                        data: data['time_on_site_data']
                      }]
                    },
                    options: {
                      animation: false,
                      spanGaps: true,
                      parsing: false,
                      title: {
                        display: false
                      },
                      legend: {
                        display: false
                      },
                      scales: {
                        xAxes: [{
                          display: false,
                          scaleLabel: {
                            display: false
                          }
                        }],
                        yAxes: [{
                          display: false,
                          scaleLabel: {
                            display: true
                          },
                          ticks: {
                            display: false,
                            beginAtZero: true
                          }
                        }]
                      },
                      elements: {
                        point: {
                          radius: 0 // default to disabled in all datasets

                        }
                      },
                      annotation: {
                        annotations: [annotation2]
                      }
                    }
                  });
                }
              }
            });
          }
        });
      });
    },
    expandPmChart: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      let icon = `<i class="icon material-icons">share</i>`;

      if (app.device.ios) {
        icon = `<i class="icon f7-icons">square_arrow_up</i>`; //
      }

      var popup = app.popup.create({
        content:
        /*html*/
        `
                    <div class="popup chart-popup">
                      <div class="page">
                        <div class="navbar">
                          <div class="navbar-bg"></div>
                          <div class="navbar-inner">
                            <div class="left"><a  class="link share-chart">${icon}</a></div>
                            <div class="title">TOS Hours</div>
                            <div class="right"><a  class="link popup-close">Close</a></div>
                          </div>
                        </div>
                        <div class="page-content display-flex align-items-center justify-content-center" style="overflow: hidden">
                            <div class="chart-container-outer" id="chart-container-outer" style="">
                            <div class="chart-container" id="chart-container" style="">
                                <div class="chart-container-inner" style="">
                                    <canvas id="cb-chart-expanded"></canvas>
                                </div>
                            </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  `,
        on: {
          opened: function () {
            setTimeout(() => {
              var ctx = document.getElementById('cb-chart-expanded');
              $$("#chart-container").css("width", $$("#chart-container-outer")[0].offsetHeight + "px");
              $$("#chart-container").css("height", $$("#chart-container-outer")[0].offsetWidth + "px");
              const annotation = {
                id: 'a-line-1',
                // optional
                drawTime: 'afterDraw',
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-0',
                borderColor: '#378cff',
                borderDash: [6, 6],
                borderDashOffset: 0,
                borderWidth: 2,
                label: {
                  enabled: true,
                  content: 'Avg: ' + window.average(self.time_on_site_data).toFixed(1),
                  position: "right"
                },
                value: window.average(self.time_on_site_data)
              };
              const customCanvasBackgroundColor = {
                id: 'customCanvasBackgroundColor',
                beforeDraw: (chart, args, options) => {
                  const {
                    ctx
                  } = chart;
                  ctx.save();
                  ctx.globalCompositeOperation = 'destination-over';
                  ctx.fillStyle = options.color || '#ffffff';
                  ctx.fillRect(0, 0, chart.width, chart.height);
                  ctx.restore();
                }
              };
              var myChart = new Chart(ctx, {
                type: 'line',
                aspectRatio: window.innerHeight * 90 / (window.innerWidth * 95),
                data: {
                  labels: self.chartsLabels,
                  datasets: [{
                    cubicInterpolationMode: "monotone",
                    lineTension: 0,
                    pointStyle: null,
                    pointRadius: 0,
                    borderWidth: 3,
                    borderColor: 'rgba(55,140,255,0.8)',
                    backgroundColor: 'rgba(55,140,255,0.1)',
                    label: 'PM Hours',
                    data: self.time_on_site_data
                  }]
                },
                options: {
                  layout: {
                    padding: 10
                  },
                  title: {
                    display: true,
                    text: ["Annual Accumulated Hours Of On-Site Works From one Year Prior", `(Total Number of Units ${self.equipments_count})`]
                  },
                  legend: {
                    display: false
                  },
                  annotation: {
                    annotations: [annotation]
                  },
                  plugins: {
                    customCanvasBackgroundColor: {
                      color: '#ffffff'
                    }
                  }
                },
                plugins: [customCanvasBackgroundColor]
              });
              console.log(myChart);
            }, 500);

            if (!window.IS_WEBAPP) {
              app.toast.create({
                icon: '<i class="icon material-icons">screen_rotation</i>',
                text: '',
                position: 'center',
                closeTimeout: 2000
              }).open();
            }
          }
        }
      });
      popup.open();
    },
    expandCbChart: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      let icon = `<i class="icon material-icons">share</i>`;

      if (app.device.ios) {
        icon = `<i class="icon f7-icons">square_arrow_up</i>`; //
      }

      var popup = app.popup.create({
        content:
        /*html*/
        `
                    <div class="popup chart-popup">
                      <div class="page">
                        <div class="navbar">
                          <div class="navbar-bg"></div>
                          <div class="navbar-inner">
                            <div class="left"><a  class="link share-chart">${icon}</a></div>
                            <div class="title">CB Number</div>
                            <div class="right"><a  class="link popup-close">Close</a></div>
                          </div>
                        </div>
                        <div class="page-content display-flex align-items-center justify-content-center" style="overflow: hidden">
                            <div class="chart-container-outer" id="chart-container-outer" style="">
                            <div class="chart-container" id="chart-container" style="">
                                <div class="chart-container-inner" style="">
                                    <canvas id="cb-chart-expanded"></canvas>
                                </div>
                            </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  `,
        on: {
          opened: function () {
            setTimeout(() => {
              var ctx = document.getElementById('cb-chart-expanded');
              $$("#chart-container").css("width", $$("#chart-container-outer")[0].offsetHeight + "px");
              $$("#chart-container").css("height", $$("#chart-container-outer")[0].offsetWidth + "px");
              const annotation = {
                id: 'a-line-1',
                // optional
                drawTime: 'afterDraw',
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-0',
                borderColor: '#378cff',
                borderDash: [6, 6],
                borderDashOffset: 0,
                borderWidth: 2,
                label: {
                  enabled: true,
                  content: 'Avg: ' + window.average(self.cbData).toFixed(1),
                  position: "right"
                },
                value: window.average(self.cbData)
              };
              const customCanvasBackgroundColor = {
                id: 'customCanvasBackgroundColor',
                beforeDraw: (chart, args, options) => {
                  const {
                    ctx
                  } = chart;
                  ctx.save();
                  ctx.globalCompositeOperation = 'destination-over';
                  ctx.fillStyle = options.color || '#ffffff';
                  ctx.fillRect(0, 0, chart.width, chart.height);
                  ctx.restore();
                }
              };
              var myChart = new Chart(ctx, {
                type: 'line',
                aspectRatio: window.innerHeight * 90 / (window.innerWidth * 95),
                data: {
                  labels: self.chartsLabels,
                  datasets: [{
                    cubicInterpolationMode: "monotone",
                    lineTension: 0,
                    pointStyle: null,
                    pointRadius: 0,
                    borderWidth: 3,
                    borderColor: 'rgba(55,140,255,0.8)',
                    backgroundColor: 'rgba(55,140,255,0.1)',
                    label: 'Call Back Number',
                    data: self.cbData
                  }]
                },
                options: {
                  layout: {
                    padding: 10
                  },
                  title: {
                    display: true,
                    text: ["Annual Callback Count From one Year Prior", `(Total Number of Units ${self.equipments_count})`]
                  },
                  legend: {
                    display: false
                  },
                  scales: {
                    yAxes: [{
                      ticks: {
                        precision: 0
                      }
                    }]
                  },
                  annotation: {
                    annotations: [annotation]
                  },
                  plugins: {
                    customCanvasBackgroundColor: {
                      color: '#ffffff'
                    }
                  }
                },
                plugins: [customCanvasBackgroundColor]
              });
            }, 500);

            if (!window.IS_WEBAPP) {
              app.toast.create({
                icon: '<i class="icon material-icons">screen_rotation</i>',
                text: '',
                position: 'center',
                closeTimeout: 2000
              }).open();
            }
          }
        }
      });
      popup.open();
    },
    rateService: function (id, rating) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      console.log(">>>>>>", this);
      $$(".active-service-" + id + " .rating-widget").removeClass("rating-1 rating-2 rating-3 rating-4 rating-5").addClass("rating-" + rating);
      app.request({
        url: Url.to("repair/rate/" + id),
        method: "POST",
        preloader: false,
        progress: true,
        data: {
          rating: rating
        },
        success: function (data, status, xhr) {
          app.toast.create({
            text: 'Thank you for your feedback!',
            closeTimeout: 2000
          }).open();
        }
      });
    },
    openActiveRequest: function (id) {
      var self = this;
      console.log(self.activerequests[id]);
      self.$router.navigate("/request-details/", {
        context: {
          request: self.activerequests[id]
        }
      });
    },
    clearReports: function (e) {
      console.warn("clearReports");
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if ($$(e.target).hasClass("sub-accordion-item")) {
        return;
      }

      self.$setState({
        maintenances: [],
        //data['maintenances'],
        repairs: [],
        //data['repairs'],
        works: [],
        //data['works'],
        grouped: {},
        loadingReports: false
      }, function () {});
    },
    loadReports: function (e, prevent) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if ($$(e.target).hasClass("sub-accordion-item")) {
        return;
      }

      if (!self.loadingReports) {
        prevent.prevent();
        self.$setState({
          loadingReports: true
        });
        app.request({
          url: Url.to("location/all-reports-by-location"),
          preloader: false,
          progress: true,
          success: function (data, status, xhr) {
            self.cachedgrouped = data;
            self.$setState({
              maintenances: [],
              //data['maintenances'],
              repairs: [],
              //data['repairs'],
              works: [],
              //data['works'],
              grouped: data['grouped']
            }, function () {
              app.accordion.open(".report-accordion-item");
              self.$setState({
                loadingReports: false,
                filterByEquipmentId: {},
                filterByEquipmentName: {}
              });
            });
          }
        });
      }
    },
    loadData: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      window.selected_location = null;

      if (self.permissions['REPORTS']) {
        app.accordion.close(".report-accordion-item");
      } //Get locations


      app.request({
        url: Url.to("location/get"),
        data: {
          'active_equipments_only': true
        },
        preloader: false,
        progress: true,
        success: function (data, status, xhr) {
          self.$setState({
            locations: data,
            oneLocation: data.length === 1
          }, function () {
            self.selectLocation(data.length > 0 ? data[0].id : null);
          });
        }
      });

      if (false) {
        app.request({
          url: Url.to("location/all-reports-by-location"),
          preloader: false,
          progress: true,
          success: function (data, status, xhr) {
            self.$setState({
              maintenances: [],
              //data['maintenances'],
              repairs: [],
              //data['repairs'],
              works: [],
              //data['works'],
              grouped: data['grouped']
            }, function () {});
          }
        });
      } //Get contracts
      // app.request({
      //     url: Url.to("contract/get"),
      //     preloader: false,
      //     progress: true,
      //     success: function (data, status, xhr) {
      //         self.$setState({
      //             contracts: data,
      //         }, function () {
      //         });
      //     },
      // });
      //Get active requests


      app.request({
        url: Url.to("repair/active-requests"),
        preloader: false,
        progress: true,
        success: function (data, status, xhr) {
          console.log(data);
          self.$setState({
            activerequests: data,
            hideSwiperNavigation: Object.keys(data).length <= 2
          }, function () {});
          self.$tick(function () {
            var swiper = self.$app.swiper.get(".active-services-container");

            if (window.IS_WEBAPP) {
              swiper.params.slidesPerView = Object.keys(self.activerequests).length > 0 ? Object.keys(self.activerequests).length === 1 ? 1.5 : 2 : 1;
              swiper.params.slidesOffsetBefore = 0;
              swiper.params.slidesOffsetAfter = 0;
              swiper.params.spaceBetween = 0;
              swiper.params.centeredSlides = Object.keys(self.activerequests).length === 1; //false;
            }

            swiper.update();
            setTimeout(function () {
              app.ptr.done('.home-ptr-content');
            }, 200);
          });
        }
      });

      if (self.permissions['CERTIFICATES']) {
        app.request({
          url: Url.to("location/count-certificates"),
          preloader: false,
          progress: true,
          success: function (data, status, xhr) {
            self.$setState({
              hide_certificates: parseInt(data) === 0
            }, function () {});
          }
        });
      }

      app.request({
        url: Url.to("notification/unread"),
        preloader: false,
        progress: false,
        success: function (data, status, xhr) {
          //console.log(data);
          if (data['count'] > 0) {
            $$("#notifications-count").text(data['count']);
            $$("#notifications-count").removeClass("display-none");
          }
        }
      });
      app.request({
        url: Url.to("data/contact-info"),
        method: "GET",
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(">>CONTACT>>", data);
          app.data.phone = data.phone;
          app.data.email = data.email;
          app.data.country = window.country;
          self.$update();
        }
      });
    },
    openLocation: function (id) {
      //console.log(id);
      var self = this;
      var router = self.$router;
      var location = {};
      self.locations.forEach(function (loc) {
        if (loc.id === id) {
          location = loc;
          return false;
        }
      });
      router.navigate("/location/", {
        context: {
          location: location
        }
      });
    },

    openReport(url) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.methods.previewPdfDocument(url); // if (window.cordova) {
      //     cordova.InAppBrowser.open(url, '_system', 'location=yes');
      // } else {
      //     window.open(url, "_system")
      // }
    },

    viewReport(id, type, url) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if (type === "Maintenance") {
        self.openReport(url);
        return;
      }

      app.request({
        url: Url.to("repair/request-details/" + id),
        preloader: true,
        progress: false,
        success: function (data, status, xhr) {
          self.$router.navigate("/request-details/", {
            context: {
              request: data,
              backButton: "Back"
            }
          });
        }
      });
    },

    viewCertificate(id, url) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var documentViewer = app.photoBrowser.create({
        photos: [url],
        theme: 'dark',
        type: 'standalone',

        renderToolbar() {
          const pb = this; //if (pb.params.renderToolbar) return pb.params.renderToolbar.call(pb);

          let iconsColor = pb.params.iconsColor;
          if (!pb.params.iconsColor && pb.params.theme === 'dark') iconsColor = 'white';
          let icon = `<i class="icon material-icons ${iconsColor ? `color-${iconsColor}` : ''}">share</i>`;

          if (app.device.ios) {
            icon = `<i class="icon f7-icons ${iconsColor ? `color-${iconsColor}` : ''}">square_arrow_up</i>`; //
          }

          const toolbarHtml = `
                              <div class="toolbar toolbar-bottom tabbar">
                                <div class="toolbar-inner">
                                  <a class="link share-current-photo">
                                    ${icon}
                                  </a>
                                </div>
                              </div>
                            `.trim();
          return toolbarHtml;
        }

      });
      documentViewer.open();
    },

    openFilter(location_id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      console.log(location_id, self.grouped.locations[location_id]);
      var filters = {};
      var buttons = [];
      Object.values(self.grouped.locations[location_id].reports).forEach(report => {
        if (!filters[report.equipment_id]) {
          filters[report.equipment_id] = report.equipment_name;
          buttons.push({
            text: report.equipment_name,
            color: 'blue',
            onClick: function () {
              self.filterByEquipmentId[location_id] = report.equipment_id;
              self.filterByEquipmentName[location_id] = report.equipment_name;
              self.$update();
              self.$tick(function () {
                $$(`.report-li-${location_id}`).addClass("display-none");
                $$(`.report-li-${location_id}[data-equipment_id="${report.equipment_id}"]`).removeClass("display-none");
              });
            }
          });
        }
      });
      console.log(filters);
      app.actions.create({
        buttons: [[{
          text: "Select Equipment",
          label: true
        }], buttons, [{
          text: "Show All",
          color: 'black',
          onClick: function () {
            delete self.filterByEquipmentId[location_id];
            delete self.filterByEquipmentName[location_id];
            self.$update();
            self.$tick(function () {
              $$(`.report-li-${location_id}`).removeClass("display-none");
            });
          }
        }], [{
          text: 'Cancel',
          color: 'red'
        }]]
      }).open();
    },

    loadCertificates: function (e, prevent) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if ($$(e.target).hasClass("sub-accordion-item")) {
        return;
      }

      if (!self.loadingCertificates) {
        prevent.prevent();
        self.$setState({
          loadingCertificates: true
        });
        app.request({
          url: Url.to("location/all-certificates-by-location"),
          preloader: false,
          progress: true,
          success: function (data, status, xhr) {
            //self.cachedgrouped = data;
            self.$setState({
              grouped: data['grouped']
            }, function () {
              app.accordion.open(".certificate-accordion-item");
              self.$setState({
                loadingCertificates: false,
                filterByEquipmentId: {},
                filterByEquipmentName: {}
              });
            });
          }
        });
      }
    },
    clearCertificates: function (e) {
      console.warn("clearCertificates", e.target);
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if ($$(e.target).hasClass("certificate-accordion-item")) {
        if ($$(e.target).hasClass("sub-accordion-item")) {
          return;
        }

        self.$setState({
          grouped: [],
          loadingCertificates: false
        }, function () {});
      }
    }
  },
  id: 'e9136a4f7d',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page navbar-extra-large" data-name="my-mitsu">\n        <!-- Top Navbar -->\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                </div>\n                <div class="title sliding">My Mitsu</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        My Mitsu\n                        <div class="right" style="top:0">\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.allowCountrySwitch, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <a class="link icon-only my-countries-select" href="#" @click="openCountrySwitcher">\n                                <div class="iti__flag iti__';
          r += c(ctx_2.country, ctx_2);
          r += '"></div>\n                            </a>\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            <a class="link icon-only no-margin-left text-color-gray" href="/account-panel/">\n<!--                                <i class="icon f7-icons">bars</i>-->\n                                <img src="';
      r += c(ctx_1.menu_icon, ctx_1);
      r += '" width="30px" style="margin-bottom: 6px;" />\n                            </a>\n                        </div>\n                        <div class="subtitle-text">What would you like to do?</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <!-- Scrollable page content-->\n        <div class="page-content  ptr-content home-ptr-content">\n            <div class="ptr-preloader">\n                <div class="preloader"></div>\n                <div class="ptr-arrow"></div>\n            </div>\n\n            <div class="home-page-layout">\n                <div>\n                <div class="active-services-swiper-wrapper">\n                    <div class="custom-swiper-button-prev swiper-button-prev show-webapp ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.hideSwiperNavigation, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'display-none';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"><i class="icon f7-icons">arrow_left_circle_fill</i></div>\n                    <div class="custom-swiper-button-next swiper-button-next show-webapp ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.hideSwiperNavigation, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'display-none';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"><i class="icon f7-icons">arrow_right_circle_fill</i></div>\n                    <div class="active-services-container swiper-container swiper-init"\n                         data-navigation=\'{"nextEl": ".custom-swiper-button-next","prevEl": ".custom-swiper-button-prev"}\'\n                         data-slides-per-view="1" data-space-between="-25" data-centered-slides="true">\n                        <!-- Slides wrapper -->\n                        <div class="swiper-wrapper">\n                            <!-- Slides -->\n                            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.activerequests, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <div class="swiper-slide">\n                                <div class="active-service active-service-';
          r += c(ctx_2.id, ctx_2);
          r += '">\n                                    <div class="active-service-header" @click="openActiveRequest(';
          r += c(ctx_2.id, ctx_2);
          r += ')">\n                                        <div class="active-service-title">\n                                            Repair service report #';
          r += c(ctx_2.id, ctx_2);
          r += '\n                                        </div>\n                                        <div class="active-service-after">\n                                            <a href="#" @click="openActiveRequest(';
          r += c(ctx_2.id, ctx_2);
          r += ')">Show more</a>\n                                        </div>\n                                    </div>\n                                    <div class="active-service-content-container">\n                                        <div class="active-service-content">\n                                            <div class="active-service-media text-align-center" @click="openActiveRequest(';
          r += c(ctx_2.id, ctx_2);
          r += ')">\n                                                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.technician, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                                <div class="active-service-image" style="background-image: url(';
              r += c(ctx_3.technician_image_url, ctx_3);
              r += ')">\n\n                                                </div>\n                                                ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                                <i class="icon material-icons">access_time</i>\n                                                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                                                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.status == 10", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                            </div>\n\n                                            ';
          r += Template7Helpers.js_if.call(ctx_2, "true || this.status != 50", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                            <div class="active-service-inner"  @click="openActiveRequest(';
              r += c(ctx_3.id, ctx_3);
              r += ')">\n                                                <div class="active-service-description">\n                                                    <div class="bold">';
              r += c(ctx_3.status_label, ctx_3);
              r += '</div>\n                                                    <div class="">';
              r += c(ctx_3.location, ctx_3);
              r += '</div>\n                                                    <div class="">';
              r += c(ctx_3.equipment, ctx_3);
              r += '</div>\n                                                    <div class="display-none">';
              r += c(ctx_3.problem, ctx_3);
              r += '</div>\n                                                </div>\n                                            </div>\n                                            ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                            <div class="active-service-inner cmplt">\n                                                <div class="active-service-description">\n                                                    <div class="bold" @click="openActiveRequest(';
              r += c(ctx_3.id, ctx_3);
              r += ')">';
              r += c(ctx_3.status_label, ctx_3);
              r += '</div>\n                                                    <div class="rating-widget rating-';
              r += c(ctx_3.rating, ctx_3);
              r += '">\n                                                        <div class="">Please rate your experience</div>\n                                                        <i class="icon material-icons" @click="rateService(';
              r += c(ctx_3.id, ctx_3);
              r += ',1)">star_fill</i>\n                                                        <i class="icon material-icons" @click="rateService(';
              r += c(ctx_3.id, ctx_3);
              r += ',2)">star_fill</i>\n                                                        <i class="icon material-icons" @click="rateService(';
              r += c(ctx_3.id, ctx_3);
              r += ',3)">star_fill</i>\n                                                        <i class="icon material-icons" @click="rateService(';
              r += c(ctx_3.id, ctx_3);
              r += ',4)">star_fill</i>\n                                                        <i class="icon material-icons" @click="rateService(';
              r += c(ctx_3.id, ctx_3);
              r += ',5)">star_fill</i>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                            <div class="active-service-inner-after" @click="openActiveRequest(';
          r += c(ctx_2.id, ctx_2);
          r += ')">\n                                                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.status == 35", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                                ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.eta, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                <div class="">ETA</div>\n                                                <div class="time text-bold">\n                                                    <small>';
                  r += c(ctx_4.eta_minutes, ctx_4);
                  r += '</small>\n                                                </div>\n                                                <!--<div class="">minutes</div>-->\n                                                ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                            </div>\n                                        </div>\n                                        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.technician, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                            <small class="text-color-gray">';
              r += c(ctx_3.technician, ctx_3);
              r += '</small>\n                                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                    </div>\n                                </div>\n                            </div>\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <div class="swiper-slide padding-vertical show-webapp">\n                                <div class="text-align-center block-title-medium padding-vertical">\n                                There are currently no active services at any of your locations\n                                </div>\n                            </div>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </div>\n                    </div>\n                </div>\n                    <div class="list accordion-list no-margin-top margin-bottom-half no-hairlines">\n                    <ul>\n                        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.permissions['CONTRACTS']", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <li class="accordion-item">\n                            <a href="#" class="item-content item-link">\n                            <div class="item-inner">\n                                <div class="item-title">Contracts</div>\n                            </div>\n                            </a>\n                            <div class="accordion-item-content">\n                                <div class="list accordion-list no-margin-top">\n                                    <ul>\n                                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.locations, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                        ';
              r += Template7Helpers.unless.call(ctx_3, ctx_2.oneLocation, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <li class="accordion-item sub-accordion-item">\n                                            <a href="#" class="item-content item-link">\n                                            <div class="item-inner">\n                                                <div class="item-title">\n                                                    ';
                  r += c(ctx_4.name, ctx_4);
                  r += '\n                                                    <div class="item-footer">';
                  r += c(ctx_4.code, ctx_4);
                  r += ' - ';
                  r += c(ctx_4.address, ctx_4);
                  r += '</div>\n                                                </div>\n                                            </div>\n                                            </a>\n                                            <div class="accordion-item-content">\n                                                <div class="list">\n                                                    <ul>\n                                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                        ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.units, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                        <li>\n                                                            <div class="item-content">\n                                                                <div class="item-inner" style="flex-wrap: wrap;">\n                                                                    <div class="item-title">\n                                                                        ';
                  r += c(ctx_4.name, ctx_4);
                  r += '\n                                                                        <div class="item-footer">';
                  r += c(ctx_4.material_label, ctx_4);
                  r += ' - ';
                  r += c(ctx_4.expiry, ctx_4);
                  r += '!</div>\n                                                                    </div>\n                                                                </div>\n                                                            </div>\n                                                            ';
                  r += Template7Helpers.unless.call(ctx_4, ctx_4.contract.can_request, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                                    <div class="links-list large-gray-link reactivate-plan-link">\n                                                                        <a href="tel:';
                      r += c(ctx_2.$root.phone, ctx_5);
                      r += '" target="_system" class="hide-webapp external padding-horizontal-half text-color-black">\n                                                                            Reactivate plan\n                                                                        </a>\n                                                                        <a href="#" data-phone="';
                      r += c(ctx_2.$root.phone, ctx_5);
                      r += '" @click="displayPhone"  class="show-webapp padding-horizontal-half text-color-black">\n                                                                            Reactivate plan\n                                                                        </a>\n                                                                    </div>\n                                                            ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                                                        </li>\n                                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                        ';
              r += Template7Helpers.unless.call(ctx_3, ctx_2.oneLocation, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                    </ul>\n                                                </div>\n                                            </div>\n                                        </li>\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                                        <li class="display-none">\n                                            <a href="#" @click="$root.gotToAddLocation" class="list-button">\n                                                Add location\n                                            </a>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </li>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.permissions['REPORTS']", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <li class="accordion-item report-accordion-item" @accordion:beforeopen="loadReports"  @accordion:closed_="clearReports">\n                            <a href="#" class="item-content item-link">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Reports\n                                        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.loadingReports, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                        <span class="preloader"></span>\n                                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                    </div>\n                                </div>\n                            </a>\n                            <div class="accordion-item-content">\n                                <div class="item-footer padding-horizontal text-color-red">Reports show the last 6 months only. For older data, contact Mitsulift.</div>\n                                <div class="list accordion-list ';
          r += Template7Helpers.if.call(ctx_2, ctx_1.oneLocation, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'margin-top';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'no-margin-top';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' padding-top">\n                                    <ul>\n                                        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.grouped.locations, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                        ';
              r += Template7Helpers.unless.call(ctx_3, ctx_2.oneLocation, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <li>\n                                            <div class="list accordion-list no-margin-top">\n                                                <ul>\n                                                    <li class="accordion-item sub-accordion-item">\n                                                        <a href="#" class="item-content item-link">\n                                                            <div class="item-inner">\n                                                                <div class="item-title">\n                                                                    ';
                  r += c(ctx_4.name, ctx_4);
                  r += '\n                                                                    <div class="item-footer">';
                  r += c(ctx_4.code, ctx_4);
                  r += ' - ';
                  r += c(ctx_4.address, ctx_4);
                  r += '</div>\n                                                                </div>\n                                                            </div>\n                                                        </a>\n                                                        <div class="accordion-item-content">\n                                                            <div class="list no-chevron">\n                                                                <ul>\n                                                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                                    <div class="text-align-right padding-horizontal-half">\n                                                                        <a href="#" class="button button-small color-gray margin-bottom-half text-align-right" @click="openFilter(';
              r += c(ctx_3.location_id, ctx_3);
              r += ')">\n                                                                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.location_id in ../filterByEquipmentId', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                                            ';
                  r += Template7Helpers.js.call(ctx_4, 'return window.okv( ../../filterByEquipmentName , this.location_id )', {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                                                                            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                                            Filter by Equipment\n                                                                            ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                                            <i class="icon material-icons">filter_list</i>\n                                                                        </a>\n                                                                    </div>\n                                                                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.reports, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                                    <li class="report-li-';
                  r += c(ctx_4.location_id, ctx_4);
                  r += '" data-equipment_id="';
                  r += c(ctx_4.equipment_id, ctx_4);
                  r += '">\n                                                                        <a href="#" class="item-link item-content" @click="viewReport(\'';
                  r += c(ctx_4.id, ctx_4);
                  r += '\', \'';
                  r += c(ctx_4.type, ctx_4);
                  r += '\', \'';
                  r += c(ctx_4.report_url, ctx_4);
                  r += '\')">\n                                                                            <div class="item-media">\n                                                                                <i class="icon material-icons text-color-gray">assignment</i>\n                                                                            </div>\n                                                                            <div class="item-inner">\n                                                                                <div class="item-title width-100" style="white-space: normal">\n                                                                                    <div class="item-header">\n                                                                                        <div class="display-flex align-items-center justify-content-space-between">\n                                                                                            <span style="white-space: nowrap">';
                  r += c(ctx_4.departed_at_formatted, ctx_4);
                  r += c(ctx_4.completed_at_formatted, ctx_4);
                  r += '</span>\n                                                                                            <span class="text-color-primary" style="white-space: nowrap">';
                  r += c(ctx_4.equipment_name, ctx_4);
                  r += '</span>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                    <small>';
                  r += c(ctx_4.type, ctx_4);
                  r += ' #';
                  r += c(ctx_4.id, ctx_4);
                  r += '</small>\n                                                                                </div>\n                                                                            </div>\n                                                                        </a>\n                                                                    </li>\n                                                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                                    ';
              r += Template7Helpers.unless.call(ctx_3, ctx_2.oneLocation, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                                                </ul>\n                                                            </div>\n                                                        </div>\n                                                    </li>\n                                                </ul>\n                                            </div>\n                                        </li>\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                    </ul>\n                                </div>\n                            </div>\n                        </li>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n\n                        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.permissions['CERTIFICATES']", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.hide_certificates, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <li class="accordion-item certificate-accordion-item" @accordion:beforeopen="loadCertificates"  @accordion:closed_="clearCertificates">\n                            <a href="#" class="item-content item-link">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Certificates\n                                        ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.loadingCertificates, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        <span class="preloader"></span>\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                    </div>\n                                </div>\n                            </a>\n                            <div class="accordion-item-content">\n                                <div class="list accordion-list no-margin-top">\n                                    <ul>\n                                        ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.grouped.locations, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                        ';
                  r += Template7Helpers.unless.call(ctx_4, ctx_3.oneLocation, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                        <li>\n                                            <div class="list accordion-list no-margin-top">\n                                                <ul>\n                                                    <li class="accordion-item sub-accordion-item">\n                                                        <a href="#" class="item-content item-link">\n                                                            <div class="item-inner">\n                                                                <div class="item-title">\n                                                                    ';
                      r += c(ctx_5.name, ctx_5);
                      r += '\n                                                                    <div class="item-footer">';
                      r += c(ctx_5.code, ctx_5);
                      r += ' - ';
                      r += c(ctx_5.address, ctx_5);
                      r += '</div>\n                                                                </div>\n                                                            </div>\n                                                        </a>\n                                                        <div class="accordion-item-content">\n                                                            <div class="list no-chevron">\n                                                                <ul>\n                                                                    ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                                                                    <div class="text-align-right padding-horizontal-half">\n                                                                        <a href="#" class="button button-small color-gray margin-bottom-half text-align-right" @click="openFilter(';
                  r += c(ctx_4.location_id, ctx_4);
                  r += ')">\n                                                                            ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.location_id in ../filterByEquipmentId', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                                            ';
                      r += Template7Helpers.js.call(ctx_5, 'return window.okv( ../../filterByEquipmentName , this.location_id )', {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n                                                                            ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                                            Filter by Equipment\n                                                                            ';
                      return r;
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                                                                            <i class="icon material-icons">filter_list</i>\n                                                                        </a>\n                                                                    </div>\n                                                                    ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.reports, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                                    <li class="report-li-';
                      r += c(ctx_5.location_id, ctx_5);
                      r += '" data-equipment_id="';
                      r += c(ctx_5.equipment_id, ctx_5);
                      r += '">\n                                                                        <a href="#" class="item-link item-content" @click="viewCertificate(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\', \'';
                      r += c(ctx_5.certificate_url, ctx_5);
                      r += '\')">\n                                                                            <div class="item-media">\n                                                                                <i class="icon material-icons text-color-gray">assignment</i>\n                                                                            </div>\n                                                                            <div class="item-inner">\n                                                                                <div class="item-title width-100" style="white-space: normal">\n                                                                                    <div class="item-header">\n                                                                                        <div class="display-flex align-items-center justify-content-space-between">\n                                                                                            <span style="white-space: nowrap">';
                      r += c(ctx_5.inspection_date, ctx_5);
                      r += '</span>\n                                                                                            <span class="text-color-primary" style="white-space: nowrap">';
                      r += c(ctx_5.equipment_name, ctx_5);
                      r += '</span>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                    <small>Certificate #<small>';
                      r += c(ctx_5.id, ctx_5);
                      r += '</small></small>\n                                                                                </div>\n                                                                            </div>\n                                                                        </a>\n                                                                    </li>\n                                                                    ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                                                                    ';
                  r += Template7Helpers.unless.call(ctx_4, ctx_3.oneLocation, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                                                </ul>\n                                                            </div>\n                                                        </div>\n                                                    </li>\n                                                </ul>\n                                            </div>\n                                        </li>\n                                        ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                    </ul>\n                                </div>\n                            </div>\n                        </li>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        <li></li>\n                    </ul>\n                </div>\n                </div>\n\n\n                <div class="list no-hairlines">\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, "this.permissions['CALL_BACK_NUMBER'] || this.permissions['TIME_ON_SITE']", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, "this.locations.length > 0", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="no-margin padding-horizontal">\n                        <div class="row">\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, "this.locations.length > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                            ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.locations, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                            <button @click="selectLocation(\'';
                      r += c(ctx_5.id, ctx_5);
                      r += '\')" class="col-33 medium-20 button button-rounded margin-bottom-half ';
                      r += Template7Helpers.js_if.call(ctx_5, 'window.selected_location == this.id', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += 'button-fill button-raised';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += 'button-outline opacity-05';
                          return r;
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '" style="">';
                      r += c(ctx_5.code, ctx_5);
                      r += '</button>\n                            ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                            <span class="col-33 medium-30"></span>\n                            <span class="col-33 medium-30"></span>\n                        </div>\n                    </div>\n                    <div class="padding-left no-padding-right">\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, "this.locations.length > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div key="';
                  r += c(ctx_4.selected_location_name, ctx_4);
                  r += '" class="location-chart-container"><small class="text-color-primary" style="font-size: 12px;">';
                  r += c(ctx_4.selected_location_name, ctx_4);
                  r += '</small></div>\n                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, "this.permissions['CALL_BACK_NUMBER']", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        <div class="location-chart-container">\n                            <div class="padding-horizontal padding-vertical-half display-flex align-items-flex-end justify-content-space-between">\n                                <div class="title-block flex-grow-4">\n                                    <div class="title">CB</div>\n                                    <div class="footer">Call back number</div>\n                                </div>\n                                ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.loadingCharts, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <div class="">\n                                    <div class="preloader"></div>\n                                </div>\n                                ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                <div class="chart margin-left-half"  @click="expandCbChart">\n                                    <canvas id="cb-chart" width="100px" height="40px">\n\n                                    </canvas>\n                                </div>\n                                <div class="count margin-left" style="width: 70px;">\n                                    <button class="button button-rounded button-fill" @click="expandCbChart">\n                                        ';
                      r += c(ctx_5.repairs_total, ctx_5);
                      r += '\n                                    </button>\n                                </div>\n                                ';
                      return r;
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                            </div>\n                        </div>\n                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n\n                        ';
              r += Template7Helpers.js_if.call(ctx_3, "this.permissions['TIME_ON_SITE']", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.enable_time_on_site_hrs_widget, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                        <div class="location-chart-container">\n                            <div class="padding-horizontal margin-vertical-half display-flex align-items-flex-end justify-content-space-between">\n                                <div class="title-block flex-grow-4">\n                                    <div class="title">TOS</div>\n                                    <div class="footer">Time on Site</div>\n                                </div>\n                                ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.loadingCharts, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                <div class="">\n                                    <div class="preloader"></div>\n                                </div>\n                                ';
                          return r;
                        },
                        inverse: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                                <div class="chart margin-left-half" @click="expandPmChart">\n                                    <canvas id="pm-chart">\n\n                                    </canvas>\n                                </div>\n                                <div class="count margin-left" style="width: 70px;">\n                                    <button class="button button-rounded button-fill" @click="expandPmChart">\n                                        ';
                          r += c(ctx_6.time_on_site_total, ctx_6);
                          r += '\n                                    </button>\n                                </div>\n                                ';
                          return r;
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n                            </div>\n                        </div>\n                        ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                    </div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n\n                <div>\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.locations.length > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="list links-list margin-5-0 display-none">\n                    <ul>\n                        <li class="large-gray-link"><a href="/request-repair/">Report a breakdown</a></li>\n                    </ul>\n                </div>\n\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, "this.permissions['MANAGE_LOCATIONS']", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="list links-list no-margin">\n                            <ul>\n                                <li class="large-gray-link">\n                                    <a href="/">Manage Locations</a>\n                                </li>\n                            </ul>\n                        </div>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="list links-list margin-5-0">\n                    <ul>\n                        <li class="large-gray-link">\n                            <a href="#" @click="$root.gotToAddLocation">Add a new Location</a>\n                        </li>\n                    </ul>\n                </div>\n                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                <div class="list buttons-list-item no-margin-top">\n                    <ul>\n                        <li>\n                            <div class="item-content">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Additional Care?\n                                        <div class="item-footer">Send us a message or call us</div>\n                                    </div>\n                                    <div class="item-after">\n                                        <div class="row">\n                                            <a href="mailto:';
      r += c(ctx_1.$root.email, ctx_1);
      r += '?subject=Bug report [';
      r += c(ctx_1.user.name, ctx_1);
      r += '][';
      r += c(ctx_1.user.id, ctx_1);
      r += '][';
      r += c(ctx_1.$root.country, ctx_1);
      r += ']" target="_system" class="col button button-outline button-round link external  display-flex align-items-center justify-content-center"><i class="icon f7-icons">chat_bubble_fill</i></a>\n                                            <a href="tel:';
      r += c(ctx_1.$root.phone, ctx_1);
      r += '" target="_system" class="hide-webapp col color-red button button-outline button-round link external display-flex align-items-center justify-content-center"><i class="icon f7-icons">phone_fill</i></a>\n                                            <a href="#" data-phone="';
      r += c(ctx_1.$root.phone, ctx_1);
      r += '" @click="displayPhone" class="show-webapp col color-red button button-outline button-round link external display-flex align-items-center justify-content-center"><i class="icon f7-icons">phone_fill</i></a>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    